import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentPreviewComponent } from './document-preview.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@NgModule({
  declarations: [DocumentPreviewComponent],
  imports: [CommonModule, NgxExtendedPdfViewerModule],
  exports: [DocumentPreviewComponent],
})
export class DocumentPreviewModule {}
